import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const updateFundsPromoCode = payload =>
  call(websocketFetch, 'update_user_spending_account_funds', payload);
